import { render, staticRenderFns } from "./CustomerInfoOther.vue?vue&type=template&id=236093c6"
import script from "./CustomerInfoOther.vue?vue&type=script&lang=js"
export * from "./CustomerInfoOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports